<template>
Confirming your booking.<br/>This shouldn't take long...
</template>

<script setup>
import { ref, onMounted } from 'vue';

const bookingCreated = ref(false);

const props = defineProps({
    paymentIntentId: {
        type: String,
        required: true,
    },
});

const checkBookingStatus = async () => {
    try {
        const response = await fetch(`/api/bookings/status?paymentIntentId=${props.paymentIntentId}`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        if (data.status === 'active') {
            bookingCreated.value = true;
            clearInterval(pollingInterval);
            // Redirect to the desired page
            // window.location.href = `/bookings/${bookingId.value}`;
          window.location.reload();
        }
    } catch (error) {
        console.error('Error checking booking status:', error);
    }
};

let pollingInterval;

onMounted(() => {
    // Start polling after booking creation
    pollingInterval = setInterval(checkBookingStatus, 1000); // Check every 5 seconds
});




</script>